import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  recordHearingConnect,
  recordTwoLineVCOConnect,
  resetHearingConnectRecord,
  resetTwoLineVCORecord,
} from 'features/reporting/store';
import { sendInfoToViThunk } from 'features/teaming/teaming-base/store';
import { CallNotificationType } from 'features/call/call-events/enums';

/**
 * Records primary hearing connection and sends notification to VI
 */
export const recordPrimaryHearingConnectThunk = createAsyncThunk(
  'reporting/recordPrimaryHearingConnect',
  async (_, { dispatch }) => {
    dispatch(recordHearingConnect());
    dispatch(
      sendInfoToViThunk(CallNotificationType.PRIMARY_HEARING_CONNECT_RECORDED)
    );
  }
);

/**
 * Records primary hearing disconnection and sends notification to VI
 */
export const recordPrimaryHearingDisconnectThunk = createAsyncThunk(
  'reporting/recordPrimaryHearingDisconnect',
  async (_, { dispatch }) => {
    dispatch(resetHearingConnectRecord());
    dispatch(
      sendInfoToViThunk(
        CallNotificationType.PRIMARY_HEARING_DISCONNECT_RECORDED
      )
    );
  }
);

/**
 * Records two-line VCO connection and sends notification to VI
 */
export const recordTwoLineVCOConnectThunk = createAsyncThunk(
  'reporting/recordTwoLineVCOConnect',
  async (_, { dispatch }) => {
    dispatch(recordTwoLineVCOConnect());
    dispatch(
      sendInfoToViThunk(CallNotificationType.TWO_LINE_VCO_CONNECT_RECORDED)
    );
  }
);

/**
 * Records two-line VCO disconnection and sends notification to VI
 */
export const recordTwoLineVCODisconnectThunk = createAsyncThunk(
  'reporting/recordTwoLineVCODisconnect',
  async (_, { dispatch }) => {
    dispatch(resetTwoLineVCORecord());
    dispatch(
      sendInfoToViThunk(CallNotificationType.TWO_LINE_VCO_DISCONNECT_RECORDED)
    );
  }
);
